module.exports = __webpack_public_path__ + "static/media/janice.57ed7c32.jpg";